import React, { useState, useEffect, useRef } from "react";
import "./Calendar.css";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useBaseUrl } from "../../ApiContext";

export default function Calendar({ onDateSelect }) {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [currentWeek, setCurrentWeek] = useState([]);
  const [prevWeek, setPrevWeek] = useState([]);
  const [nextWeek, setNextWeek] = useState([]);
  const [activeWeekId, setActiveWeekId] = useState(0);
  const [activeWeek, setActiveWeek] = useState(currentWeek);
  const [activeDay, setActiveDay] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const innerDaySelectorRef = useRef(null);

  const handleNextWeek = () => {
    setActiveWeekId((prevId) => {
      if (prevId < 1) {
        return prevId + 1;
      } else {
        return 1;
      }
    });
  };
  const handlePrevWeek = () => {
    setActiveWeekId((prevId) => {
      if (prevId > -1) {
        return prevId - 1;
      } else {
        return -1;
      }
    });
  };
  useEffect(() => {
    const fetchCalendar = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/main_page/week`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        const data = response.data;
        setCurrentWeek(data.current_week);
        setPrevWeek(data.previous_week);
        setNextWeek(data.next_week);
        setActiveDay(data.date.show_date.day);
        onDateSelect(data.date.call_date);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during calendar request", error);
      }
    };
    if (userToken) {
      fetchCalendar();
    }
  }, [userToken, baseUrl]);

  useEffect(() => {
    if (activeWeekId === 0) {
      setActiveWeek(currentWeek);
    } else if (activeWeekId === 1) {
      setActiveWeek(nextWeek);
    } else if (activeWeekId === -1) {
      setActiveWeek(prevWeek);
    }
  }, [currentWeek, nextWeek, prevWeek, activeWeekId]);

  const handleDateClick = (day) => {
    if (onDateSelect) {
      onDateSelect(day.date.call_date);
      setActiveDay(day.date.show_date.day);
    }
  };

  useEffect(() => {
    const scrollCalendarToActiveDay = () => {
      const activeDayElement = document.querySelector(".activeDay");
      if (activeDayElement) {
        const container = innerDaySelectorRef.current;
        const containerRect = container.getBoundingClientRect();
        const activeDayRect = activeDayElement.getBoundingClientRect();
        const scrollLeft =
          activeDayRect.left -
          containerRect.left -
          container.offsetWidth +
          activeDayRect.width;
        container.scrollLeft = scrollLeft;
      }
    };
    requestAnimationFrame(scrollCalendarToActiveDay);
  }, [isLoading]);

  return (
    <div className="calendarWrapper centeredFlex">
      <img
        src="/images/rightPolygon.svg"
        alt="arrow right"
        onClick={handlePrevWeek}
      />
      <div className="daySelectorContainer scroll" ref={innerDaySelectorRef}>
        {!isLoading && (
          <div className="innerDaySelector">
            {activeWeek.length > 0 &&
              activeWeek.map((day, index) => (
                <div
                  key={index}
                  className={`inactiveDay centeredFlex ${
                    day.date.show_date.day == activeDay ? "activeDay" : ""
                  }`}
                  onClick={() => handleDateClick(day)}
                >
                  <span className="calendarDate">{day.date.show_date.day}</span>
                  <span className="calendarWeekday">{day.date.weekday}</span>
                </div>
              ))}
          </div>
        )}
      </div>
      <img src="/images/leftPolygon.svg" alt="arrow" onClick={handleNextWeek} />
    </div>
  );
}
